<script>
  import { getContext, onMount } from "svelte";
  import { useLocation } from "svelte-routing";
  import { get } from "svelte/store";

  const context = getContext("location");

  const location = useLocation();
  let previous = null;
  let d = get(location);
  if (d) previous = d.pathname;

  const unsub = location.subscribe((loc) => {
    const newLoc = loc.pathname;
    if (context) context.setLocation(newLoc, newLoc !== previous);
    previous = newLoc;
  });
  onMount(() => {
    return unsub;
  });
</script>

<slot></slot>
